<template>
  <v-layout column>
    <v-flex xs12>
      <!-- Filtros -->
      <v-card v-if="filtros" class="mb-4">
        <v-toolbar dense color="grey lighten-2">
          <v-toolbar-title class="title">Filtros</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat icon @click="filtros = false" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          
          <v-tooltip bottom>
            <v-btn fab dark small color="primary" icon @click="aplicaFiltros" slot="activator">
              <v-icon>done</v-icon>
            </v-btn>
            <span>Aplicar</span>
          </v-tooltip>
        </v-toolbar>
        <v-container fluid grid-list-xl>
          <v-layout row wrap>
            <v-flex xs12 md3>
              <v-select
                v-model="filtroSelected"
                :items="filtroOcorrencias"
                item-text="text"
                item-value="value"
                prepend-icon="description"
                label="Filtrar Ocorrências"
                no-data-text="Nenhum registro encontrado"
              ></v-select>
            </v-flex>
            <v-flex xs12 md3 v-if="filtroSelected == 'periodo'">
              <v-menu v-model="periodoDatepickerInicial" :close-on-content-click="false" full-width>
                <v-text-field readonly slot="activator"
                  :value="moment(periodo.dataInicial).format('DD/MM/YYYY')" label="Data Inicial" prepend-icon="event">
                </v-text-field>
                <v-date-picker @change="periodoDatepickerInicial = false" locale="pt" v-model="periodo.dataInicial"></v-date-picker>
              </v-menu>
              <v-menu v-model="periodoDatepickerFinal" :close-on-content-click="false" full-width>
                <v-text-field readonly slot="activator"
                  :value="moment(periodo.dataFinal).format('DD/MM/YYYY')" label="Data Final" prepend-icon="event">
                </v-text-field>
                <v-date-picker @change="periodoDatepickerFinal = false" locale="pt" v-model="periodo.dataFinal"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex v-if="colaboradoresSelected.length" xs12 md3>
              <v-select
                v-model="colaboradorSelected"
                :items="computedColaboradores"
                item-text="Descricao"
                return-object
                prepend-icon="description"
                label="Colaborador"
                no-data-text="Nenhum registro encontrado"
                @change="changeColaborador"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <div :class="filtros ? '' : 'pos-abs-fixed'">
        <v-toolbar 
          color="grey lighten-2"
          dense
        >
          <!-- <v-toolbar-title class="title">{{ pageTitle }}</v-toolbar-title> -->
          <v-flex md3>
            <v-select
              v-model="layoutSelected"
              :items="layoutsSql"
              item-text="Descricao"
              return-object
              no-data-text="Nenhum registro encontrado"
              @change="changeLayoutSql"
            ></v-select>
          </v-flex>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <span 
            v-if="this.filtroSelected === 'periodo' && $vuetify.breakpoint.mdAndUp"
            class="font-weight-bold"
          >
            <v-icon small>event</v-icon> {{ periodoSelected }}
          </span>
          <v-spacer></v-spacer>
          <!-- <v-flex xs4 px-3>
            <v-text-field prepend-inner-icon="search" clearable v-model="searchTerm"></v-text-field>
          </v-flex> -->
          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="aplicaFiltros" :loading="loading">
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Atualizar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="filtros = !filtros">
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Filtros</span>
          </v-tooltip>
        </v-toolbar>
      </div>
    </v-flex>
    <v-flex xs12>
      <v-container fluid grid-list-xl>
        <v-layout row wrap justify-center align-center>
          <v-flex v-if="colaboradorSelected" xs12 md3>
            <v-card>
              <v-card-title class="font-weight-bold">
                <v-flex pa-0 class="text-xs-center">
                  <span v-if="$vuetify.breakpoint.mdAndUp" class="pr-1">Colaborador:</span>
                  <span class="pr-2">{{ colaboradorSelected }}</span>
                  <v-icon @click.stop="removeColaborador" color="error" small>close</v-icon>
                </v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
          <v-flex xs12 md3>
            <v-card>
              <v-card-title class="font-weight-bold">
                <v-flex pa-0 class="text-xs-center">
                  Ocorrências: {{ totalOcorrenciasColaboradorSelected }}
                </v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
          <v-flex xs12 md3>
            <v-card>
              <v-card-title class="font-weight-bold">
                <v-flex pa-0 class="text-xs-center">
                  Duração: {{ totalDuracaoOcorrencias }}
                </v-flex>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex
            xs12
            lg9
            v-for="(item, index) in computedItemsGrouped"
            :key="index"
          >
            <CardOcorrencia
              :atividade="item"
              @paraExecucaoOcorrencia="$emit('paraExecucaoOcorrencia', $event)"
              @finalizaOcorrenciaModal="$emit('finalizaOcorrenciaModal', $event)"
            />
          </v-flex>
        </v-layout>
        <v-layout row justify-center>
          <v-flex xs12 lg9 v-if="totalPages" class="text-xs-center">
            <v-pagination
              v-model="page"
              :length="totalPages"
              @input="salvaPaginacaoAtual"
              @next="scrollTopo"
              @previous="scrollTopo"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import CardOcorrencia from '@/components/atividade/CardOcorrencia';
import marked from 'marked';

export default {
  props: ["items", "loading", "title"],
  name: "NewGridAtividadesOcorrencias",
  components: {
    CardOcorrencia,
  },
  data: () => ({
    page: 1,
    gridSelected: 'lista',
    colaboradorSelected: null,
    tiposRecursoSelected: [],
    colaboradoresSelected: [],
    statusSelected: [],
    filtroSelected: 'periodo',
    filtroOcorrencias: [
      // { text: 'Minhas Ocorrências', value: 'minhas' },
      { text: 'Período', value: 'periodo' },
    ],
    filtros: false,
    layoutSelected: null,
    searchTerm: '',
    periodoDatepickerInicial: false,
    periodoDatepickerFinal: false,
    periodo: {
      dataInicial: new Date().toISOString().substr(0, 10),
      dataFinal: new Date().toISOString().substr(0, 10)
    },
  }),
  computed: {
    ...mapGetters(["user", "layoutsSql", "colaboradores"]),
    pageTitle() {
      return this.title ? this.title : 'Título';
    },
    uniqueItems() {
      const ocorrenciasGrouped = [];
      
      if (this.colaboradoresSelected.length && this.colaboradorSelected) {
        const colaboradorSelectedItems = this.items.filter(item => item.Colaborador == this.colaboradorSelected);
        const idsAtividades = Array.from(new Set(colaboradorSelectedItems.map(item => item.IdAtividade)));

        if (idsAtividades) {
          idsAtividades.forEach(id => {
            const atividade = {};
            atividade.IdAtividade = id;
            atividade.Ocorrencias = colaboradorSelectedItems.filter(item => item.IdAtividade == id);
            atividade.Atividade = 
              atividade.Ocorrencias.length ?
              atividade.Ocorrencias[0].Atividade : '';
            atividade.Clientes = 
              atividade.Ocorrencias.length ?
              atividade.Ocorrencias[0].Clientes : '';

            ocorrenciasGrouped.push(atividade);
          });
        }
      } else {
        const idsAtividades = Array.from(new Set(this.items.map(item => item.IdAtividade)));

        if (idsAtividades) {
          idsAtividades.forEach(id => {
            const atividade = {};
            atividade.IdAtividade = id;
            atividade.Ocorrencias = this.items.filter(item => item.IdAtividade == id);
            atividade.Atividade = 
              atividade.Ocorrencias.length ?
              atividade.Ocorrencias[0].Atividade : '';
            atividade.Clientes = 
              atividade.Ocorrencias.length ?
              atividade.Ocorrencias[0].Clientes : '';

            ocorrenciasGrouped.push(atividade);
          });
        }
      }
      return ocorrenciasGrouped;
    },
    computedItemsGrouped() {
      if (this.colaboradoresSelected.length && this.colaboradorSelected) {
        const inicio = (this.page - 1) * 10,
              fim = inicio + 10;
        
        return this.uniqueItems.filter(item => item.Ocorrencias.filter(ocorrencia => ocorrencia.IdColaborador === this.colaboradorSelected)).slice(inicio, fim);
        // return this.items.filter(item => item.Colaborador === this.colaboradorSelected).slice(inicio, fim);
      } else {
        const inicio = (this.page - 1) * 10,
              fim = inicio + 10;
        return this.uniqueItems.slice(inicio, fim);
      }
    },
    computedItems() {
      if (this.colaboradoresSelected.length && this.colaboradorSelected) {
        const inicio = (this.page - 1) * 10,
              fim = inicio + 10;

        return this.items.filter(item => item.Colaborador === this.colaboradorSelected).slice(inicio, fim);
      } else if (!this.colaboradoresSelected.length && !this.colaboradorSelected) {
        const inicio = (this.page - 1) * 10,
              fim = inicio + 10;
        return this.items.slice(inicio, fim);
      } else {
        return [];
      }
    },
    // Computed property para montar o array de colaboradores de acordo com os IDs
    computedColaboradores: {
      get() {
        const colaboradores = [];
          this.colaboradores.filter(colaborador => {
            JSON.parse(this.layoutSelected.Configuracoes).colaboradoresSelected.forEach(colaboradorSelected => {
              if (colaborador.IdColaborador == colaboradorSelected) colaboradores.push(colaborador);
            });
          });
          // return colaboradores;
          // Filtra os colaboradores que estão nas ocorrências
          const colaboradoresOcorrencia = [];
          for (const col of colaboradores) {
            for (const item of this.items) {
              if (col.IdColaborador == item.IdColaborador) {
                colaboradoresOcorrencia.push(col);
              }
            }
          }
          return colaboradoresOcorrencia;
      },
      set(value) {
        this.colaboradoresSelected = value;
      }
    },
    totalOcorrenciasColaboradorSelected() {
      if (this.colaboradorSelected) {
        return this.items.filter(item => item.Colaborador === this.colaboradorSelected).length;
      } else {
        return this.items.length;
      }
    },
    totalPages() {
      const pages = Math.ceil(this.uniqueItems.length / 10);
      localStorage.setItem('newGridAtividadesOcorrenciasTotalPages', pages);
      return pages;
    },
    periodoSelected() {
      const { dataInicial, dataFinal } = this.periodo;
      const dataInicialFormatada = this.moment(dataInicial).format('DD/MM/YYYY');
      const dataFinalFormatada = this.moment(dataFinal).format('DD/MM/YYYY');
      const periodoFormatado = `${dataInicialFormatada} à ${dataFinalFormatada}`

      return periodoFormatado;
    },
    totalDuracaoOcorrencias() {
      let inicio = new Date(1970, 0, 1, 0, 0, 0);
      let duracoes = [];
      
      if (this.colaboradorSelected) {
        this.items
          .filter(item => item.Duracao !== null)
          .filter(item2 => item2.Colaborador === this.colaboradorSelected)
          .map(item3 => {
            const duracao = this.moment(item3.Duracao).format('HH:mm');
            duracoes.push(duracao);
          });
      } else {
        this.items
          .filter(item => item.Duracao !== null)
          .map(item2 => {
            const duracao = this.moment(item2.Duracao).format('HH:mm');
            duracoes.push(duracao);
          });
      }

      const duracoesTotal = duracoes.slice(1)
        .reduce((prev, cur) => this.moment.duration(cur).add(prev),
          this.moment.duration(duracoes[0]));

      let final = this.moment(inicio).add(duracoesTotal);
      let ms = this.moment(final, 'DD/MM/YYYY HH:mm:ss').diff(this.moment(inicio, 'DD/MM/YYYY HH:mm:ss'));
      let duration = this.moment.duration(ms);
      let duracaoFinal = Math.floor(duration.asHours()) + this.moment(ms).format(":mm");
      return duracaoFinal;
    },
  },
  methods: {
    ...mapMutations(['showNotification', 'closeNotification']),
    ...mapActions([
      "fetchLayoutsSql",
      "fetchLayoutsSqlUsuario",
    ]),
    ...mapMutations(["showNotification", "closeNotification"]),
    compileMarkdown(text) {
      return marked(text);
    },
    scrollTopo() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    salvaPaginacaoAtual(page) {
      localStorage.setItem('newGridAtividadesOcorrenciasPage', page);
      this.scrollTopo();
    },
    recuperaPaginacaoSalva() {
      if (localStorage.getItem('newGridAtividadesOcorrenciasPage')) {
        const savedPage = localStorage.getItem('newGridAtividadesOcorrenciasPage');
        this.page = Number(savedPage);
      }
    },
    aplicaFiltros() {
      if (this.filtroSelected == 'periodo') {
        this.$emit('aplicaFiltros', this.periodo);
        this.filtros = false;
        this.page = 1;
      } else {
        this.$emit('aplicaFiltros');
        this.filtros = false;
        this.page = 1;
      }
      this.salvaConfigPesquisa();
    },
    changeLayoutSql(obj) {
      if (!JSON.parse(obj.Configuracoes).colaboradoresSelected.length && this.colaboradorSelected) {
        this.removeColaborador();
      }
      this.$emit('changeLayoutSql', obj.IdLayoutSql);
      this.preparaFiltrosLayout();
      this.aplicaFiltros();
    },
    changeColaborador(obj) {
      this.colaboradorSelected = obj.Descricao;
      localStorage.setItem("colaboradorSelected", this.colaboradorSelected);
    },
    removeColaborador() {
      this.colaboradorSelected = null;
      localStorage.removeItem('colaboradorSelected');
      this.showNotification({ text: 'Colaborador removido do filtro.', status: 'success' });
    },
    ocorrenciaFinal(tipoOcorrencia) {
      return tipoOcorrencia === 3 ? 'success' : '';
    },
    statusOcorrencia(status) {
      if (status.includes('P')) return "#263238";
      if (status.includes('F')) return "#1976d2";
      if (status.includes('C')) return "#bdbdbd";
    },
    alteraGrid() {      
      this.gridSelected = this.gridSelected === 'lista' ? 'coluna' : 'lista';
    },
    salvaConfigPesquisa() {
      // this.searchTerm ? localStorage.setItem("searchTerm", this.searchTerm) : localStorage.setItem("searchTerm", "");
      // localStorage.setItem("defaultPagConfig", JSON.stringify(this.defaultPagConfig));
      this.colaboradorSelected ? localStorage.setItem("colaboradorSelected", this.colaboradorSelected) : '';
      localStorage.setItem("layoutSelectedOcorrencias", this.layoutSelected.IdLayoutSql);
      localStorage.setItem('filtroSelectedOcorrencias', this.filtroSelected);
      localStorage.setItem('periodo', JSON.stringify(this.periodo));
    },
    recuperaConfigPesquisa() {
      if (localStorage.getItem('colaboradorSelected')) {
        this.colaboradorSelected = localStorage.getItem('colaboradorSelected');
      } else {
        this.colaboradorSelected = '';
      }

      if (localStorage.getItem('filtroSelectedOcorrencias')) {
        this.filtroSelected = localStorage.getItem('filtroSelectedOcorrencias');
        if (this.filtroSelected == 'periodo') {
          this.periodo = JSON.parse(localStorage.getItem('periodo'));
        }
      } else {
        this.filtroSelected = 'periodo';
      }

      if (localStorage.getItem("layoutSelectedOcorrencias")) {
        const id = localStorage.getItem("layoutSelectedOcorrencias");
        this.layoutSelected = this.buscaIdUltimoLayoutsql(id);
        this.preparaFiltrosLayout();
      } else {
        this.buscaUltimoLayoutSql();
        this.preparaFiltrosLayout();
      }
    },
    preparaFiltrosLayout() {
      this.tiposRecursoSelected = JSON.parse(this.layoutSelected.Configuracoes).tiposRecursoSelected.map(tipo => tipo.Descricao);
      this.situacoesSelected = JSON.parse(this.layoutSelected.Configuracoes).situacoesSelected.map(situacao => situacao.Descricao);
      this.colaboradoresSelected = JSON.parse(this.layoutSelected.Configuracoes).colaboradoresSelected.map(colaborador => colaborador.Descricao);
      this.statusSelected = JSON.parse(this.layoutSelected.Configuracoes).statusSelected;
      this.gridSelected = JSON.parse(this.layoutSelected.Configuracoes).tipoVisualizacao;
    },
    buscaUltimoLayoutSql() {
      this.layoutSelected = this.layoutsSql[this.layoutsSql.length - 1];
    },
    buscaIdUltimoLayoutsql(id) {
      return this.layoutsSql.filter(layout => layout.IdLayoutSql == id)[0];
    },
    async inicializaLayoutSql() {
      const layoutSql = this.buscaIdUltimoLayoutsql(this.layoutSelected.IdLayoutSql);
      this.changeLayoutSql(layoutSql);
    },
    // Emissão de eventos para o componente pai
    emiteEvento(payload) {
      this.$emit(payload.evento, payload.item);
    }
  },
  async created() {
    await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100004 });
    this.recuperaConfigPesquisa();
    this.inicializaLayoutSql();
    this.recuperaPaginacaoSalva();
  }
};
</script>

<style scoped>
.pos-abs-fixed {
  z-index: 5;
  position: relative;
  padding-bottom: 50px;
}
.pos-abs-fixed > :first-child {
  position: fixed;
}
.cursor-pointer {
  cursor: pointer;
}
.prewrap {
  white-space: pre-wrap;
}
</style>